import { ScriptDef, ScriptTheme } from '../../types';

export const SHORT_SCRIPTS: ScriptDef[] = [
    {
        id: 'SCRIPT_012',
        name: '半路人家',
        genre: 'short',
        synopsis: '二〇二三年县城融媒体剪辑员阮棠溪加班猝倒，醒来成了 1983 年东北红旗纺织厂供销社的营业员——一个二十六岁没嫁、被全厂喊"老姑娘"的远房侄女。单位分房只认双职工结婚，为了那间十二平米的单间，她和仓库保管员屠长林商量着把证领了。证是真的，婚是名义上的：她踩缝纫机给半条街做衣裳，"个体户"这个词一出口，整个家属院都替这桩假婚姻捏汗。',
        roles: [
            {
                name: '阮棠溪',
                roleType: '女主角',
                billing: 1,
                intro: '前世剪了五年专题片，最会从废素材里找出好故事。穿来头一件事是把媒人堵在门口：证可以领，婚不用办。她的算盘打得响——攒钱、盘铺面、等政策松一松，独独没算到为分房领的证，日子会过成真的。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { charm: 3, talent: 2 },
            },
            {
                name: '屠长林',
                roleType: '男主角',
                billing: 1,
                intro: '仓库保管员，三班倒，全厂的账他盘得一丝不差，自己的日子过得一模样两样——三十一岁没成家，姐姐塞的相亲条子摞了一抽屉。应下假结婚的理由像句实话："房分下来你住着，我值宿舍去。"',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'temperament', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { charm: 3, temperament: 2 },
            },
            {
                name: '屠长秋',
                roleType: '女配角',
                billing: 3,
                intro: '屠长林之姐，全家第一个跳出来骂胡闹的，又第一个把娘家的缝纫机搬了过来。嘴上不认这个弟媳，手上的事一件没少干。',
                level: 2,
                gender: 'female',
                requirements: [{ attr: 'temperament', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { temperament: 3 },
            },
            {
                name: '屠小霜',
                roleType: '女配角',
                billing: 5,
                intro: '屠家幺女，纺织厂新进挡车工，休班就往嫂子的缝纫摊上凑，帮着锁边看摊。',
                level: 1,
                gender: 'female',
                requirements: [{ attr: 'charm', value: 5 }],
                shootWeeks: 1,
                attributeGrowth: { charm: 2 },
            }
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Period, ScriptTheme.LifeStyle],
        heat: 16,
        baseScore: 6.5,
    },
    {
        id: 'SCRIPT_013',
        name: '金丝笼',
        genre: 'short',
        synopsis: '一九三六年汉口。码头公所新来的账房先生年纪轻、算盘快，唯独酒量浅得可疑——没人知道"他"是五年前沉船案船主之女苏折枝，进公所只为翻一本落了灰的旧账。常驻茶楼的闲散商人郁临川，白天陪会长霍藏舟吃茶，夜里给报馆写匿名稿。她查沉船，他查军火，两个揣着假身份的人，在同一本流水账上撞了个正着。',
        roles: [
            {
                name: '苏折枝',
                roleType: '女主角',
                billing: 1,
                intro: '父亲下葬那天没找到尸首，她收起女装也收起名字，以远房侄子的身份进公所做账房。算盘是童子功，恨也是。查案的路子不聪明，就是肯等——从船埠的老更夫到洋行的买办，一处一处磨过去。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'wisdom', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { charm: 3, wisdom: 2 },
            },
            {
                name: '郁临川',
                roleType: '男主角',
                billing: 1,
                intro: '报馆社会版记者，笔名"汉上闲人"。写稿是好手，装闲人是硬学的，茶楼里坐出两个烫才有人当他真是收古玩的。他盯的是公所背后过手的军火，盯到一半，先盯住了那个账目太干净的年轻账房。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'wisdom', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { charm: 3, wisdom: 2 },
            },
            {
                name: '阿丙',
                roleType: '男配角',
                billing: 4,
                intro: '茶楼跑堂，眼尖嘴紧，贵客落座前茶碗必先摆正，账房先生多坐一炷香他心里就有数。',
                level: 1,
                gender: 'male',
                requirements: [{ attr: 'temperament', value: 5 }],
                shootWeeks: 1,
                attributeGrowth: { temperament: 2 },
            }
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Mystery, ScriptTheme.Period, ScriptTheme.Crime],
        heat: 24,
        baseScore: 6.8,
    },
    {
        id: 'SCRIPT_014',
        name: '老兵不装了',
        genre: 'short',
        synopsis: '复员三年，侦察班长骆青野开着冷链货车跑长途，一等功证书压在行李箱夹层，抚恤金全打给了牺牲战友的家。相亲认识的婚庆策划米霓不嫌他穷，她哥米大仓嫌——这位物流老板处处给"未来姐夫"使绊子，逼他低头。直到高速隧道里一辆危化品车追尾，堵在场的人里，只有他知道该先断哪根线。',
        roles: [
            {
                name: '骆青野',
                roleType: '男主角',
                billing: 1,
                intro: '带了五年兵，管三十个人比管一辆车熟。车头上挂个平安结，是战友遗孤系的绳。保密协议在，荣誉就说不出口，被当成窝囊废也不辩解——他救人从来不为证明什么。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'stamina', value: 30 },
                    { attr: 'charm', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { stamina: 3, charm: 2 },
            },
            {
                name: '米霓',
                roleType: '女主角',
                billing: 1,
                intro: '婚庆策划，见惯排场，最不吃排场那套。哥逼她分手，她把哥堵姐夫的事一件件写在纸上贴冰箱。她说看人先看手，骆青野握方向盘那只手，虎口的茧比她爸的还厚。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { charm: 3, talent: 2 },
            },
            {
                name: '米大仓',
                roleType: '男二号',
                billing: 2,
                intro: '物流公司老板，认钱也认面子。压价、抢线、举报超载，招招不见血。隧道那晚他的车队也在，散场后他撕了举报信，逢人不再喊"那司机"，改口叫青野。',
                level: 3,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 18 },
                    { attr: 'charm', value: 15 },
                ],
                shootWeeks: 2,
                attributeGrowth: { temperament: 2, charm: 2 },
            },
            {
                name: '马壮',
                roleType: '男配角',
                billing: 5,
                intro: '冷链公司新调度员，管派单的小年轻，嘴上没个正经，派起单来比谁都公道。',
                level: 1,
                gender: 'male',
                requirements: [{ attr: 'charm', value: 5 }],
                shootWeeks: 1,
                attributeGrowth: { charm: 2 },
            }
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Military, ScriptTheme.Urban, ScriptTheme.Romance],
        heat: 17,
        baseScore: 5.8,
    },
    {
        id: 'SCRIPT_015',
        name: '我家老头上热搜了',
        genre: 'short',
        synopsis: '邴秀珍在公交公司干了三十年售票员，线路取消后退了休，和公园里认识的退休游泳教练蒲慕舟处了三个月，把证领了。婚事被女儿剪成短视频，一条"大爷深藏不露"的弹幕越传越真，全网认定蒲慕舟是退隐船王——他越澄清，网友越信。品牌方、认亲的、卖"传家玉"的潮水般涌来，两位老人拿对付早晚高峰的耐心，应付这场跟他们没关系的豪门大戏。',
        roles: [
            {
                name: '邴甜甜',
                roleType: '女二号',
                billing: 2,
                intro: '邴秀珍之女，直播运营。"我妈闪婚"系列涨粉百万，豪门叙事一半是网友编的，一半是她顺水推舟剪出来的。收手那天，她把剪辑台上"船王"相关的素材全拖进了回收站。',
                level: 2,
                gender: 'female',
                requirements: [{ attr: 'charm', value: 12 }],
                shootWeeks: 2,
                attributeGrowth: { charm: 3 },
            },
            {
                name: '蒲建平',
                roleType: '男二号',
                billing: 2,
                intro: '蒲慕舟之子，在外地做工程，赶回来劝阻婚事，反被谣言顶到风口——有人冒充他的"同父异母妹妹"上门认亲行骗。他报案、跟警方对剧本，一边辟谣，一边才认了这位继母。',
                level: 2,
                gender: 'male',
                requirements: [{ attr: 'temperament', value: 12 }],
                shootWeeks: 2,
                attributeGrowth: { temperament: 3 },
            }
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Urban, ScriptTheme.Romance, ScriptTheme.Comedy],
        heat: 16,
        baseScore: 4.4,
    },
    {
        id: 'SCRIPT_016',
        name: '萌宝探班记',
        genre: 'short',
        synopsis: '横店服装组长蔺星晚带大的五岁儿子年糕，被副导演一眼相中进组演个小男孩——对手戏演员闻镜洲，正是五年前被家里送出国、从此断联的大学恋人，如今的新任出品人。闻镜洲没认出故人，先被小群演圈了粉，天天塞糖。蔺星晚本想拍完这部就带儿子走，可年糕把片场当成了游乐场，也当成了撮合现场。',
        roles: [
            {
                name: '蔺星晚',
                roleType: '女主角',
                billing: 1,
                intro: '童星出身，长大后没红起来，转了幕后。服装组的账她管得清，感情的账五年没敢翻。对闻镜洲公事公办，工装口袋里却一直装着一张大学话剧社的旧票根。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { charm: 3, talent: 2 },
            },
            {
                name: '闻镜洲',
                roleType: '男主角',
                billing: 1,
                intro: '家里逼着接班的独子，回国头一件事是投了部小成本戏给自己练手。片场什么都新鲜，对小演员有耐心，尤其对那个总来蹭监视器的小孩——说不清为什么，就是想给这孩子多留几场戏。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { charm: 3, talent: 2 },
            },
            {
                name: '小满姐',
                roleType: '女配角',
                billing: 5,
                intro: '片场跟机员，扛着监视器满场跑，年糕摔倒了第一个冲过去扶，道具组的椅子也归她摆。',
                level: 1,
                gender: 'female',
                requirements: [{ attr: 'charm', value: 5 }],
                shootWeeks: 1,
                attributeGrowth: { charm: 2 },
            }
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.LifeStyle, ScriptTheme.Urban, ScriptTheme.Romance],
        heat: 20,
        baseScore: 6.1,
    },
    {
        id: 'SCRIPT_017',
        name: '凤座',
        genre: 'short',
        synopsis: '绣房庶女柳拂霜入尚宫局那年，姐姐因一件绣错的凤袍被赐死已满三年。她手上有姐姐的真传，心里有没抄完的冤案名单，从针线房最末等一路往上爬。执掌凤印的崔贵妃欣赏她的手，也忌惮她的眼。等她终于坐上凤座下首那张椅子，翻开当年凤袍的图样——针脚没有错，错的是挑针的人心。',
        roles: [
            {
                name: '柳拂霜',
                roleType: '女主角',
                billing: 1,
                intro: '庶出，绣艺得其母真传，过图不忘。进宫不为自己，上位的手却不软——用谁、舍谁、什么时候认错，算得比谁都快。爬得越高她越明白，姐姐不是死在针脚上。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'wisdom', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { charm: 3, wisdom: 2 },
            },
            {
                name: '崔含章',
                roleType: '女二号',
                billing: 2,
                intro: '贵妃，执掌凤印八年，笑得最好看的时候最危险。她未必是害姐姐的人，但一定是把宫规当刀使的人。她对柳拂霜半是提拔半是养蛊——养一条随时咬得回自己的蛊。',
                level: 3,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 18 },
                    { attr: 'charm', value: 15 },
                ],
                shootWeeks: 2,
                attributeGrowth: { temperament: 2, charm: 2 },
            },
            {
                name: '沈流苏',
                roleType: '女配角',
                billing: 3,
                intro: '尚宫局女官，柳拂霜上位的引路人。教她规矩，也教她哪条规矩能破。宫里人只当她圆滑，没人知道她抽屉里压着一张离宫的船票，一压六年。',
                level: 2,
                gender: 'female',
                requirements: [{ attr: 'charm', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { charm: 3 },
            },
            {
                name: '承熙帝',
                roleType: '男配角',
                billing: 4,
                intro: '戏份不多，分量不轻。凤袍案当年他一句"按祖制办"定了生死，如今愈发疑心那件凤袍错得蹊跷。',
                level: 2,
                gender: 'male',
                requirements: [{ attr: 'temperament', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { temperament: 3 },
            },
            {
                name: '粗使宫女',
                roleType: '女配角',
                billing: 5,
                intro: '针线房外洒扫提水的粗使宫女，井台边的消息最灵——柳拂霜每回打水，她都有新鲜八卦。',
                level: 1,
                gender: 'female',
                requirements: [{ attr: 'stamina', value: 8 }],
                shootWeeks: 1,
                attributeGrowth: { stamina: 3 },
            }
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Court, ScriptTheme.Scheme],
        heat: 19,
        baseScore: 5.4,
    },
    {
        id: 'SCRIPT_018',
        name: '一九九六的雪',
        genre: 'short',
        synopsis: '一九九六年冬，红钢厂的裁员名单贴出来，检修工关德海的名字在第三列。他没敢告诉家里，照旧揣着饭盒出门，在劳务市场蹲一天，天黑再回家。妻子曲凤霞在副食店早看出不对——饭盒里的菜一天比一天凉。没吵没闹，她把里屋的缝纫机搬出来，两口子在天桥下支了个改衣摊。雪一场接一场，摊子没塌，家也没塌。',
        roles: [
            {
                name: '关冬冬',
                roleType: '男二号',
                billing: 2,
                intro: '高三，成绩中游，心眼细。发现爸天天穿工装出门、身上却没有机油味，跟妈对了个眼神，俩人谁也没说破。他悄悄退了补习班，钱塞进摊位的铁盒。',
                level: 3,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 18 },
                    { attr: 'wisdom', value: 15 },
                ],
                shootWeeks: 2,
                attributeGrowth: { charm: 2, wisdom: 2 },
            },
            {
                name: '关小雪',
                roleType: '女配角',
                billing: 5,
                intro: '关家小女儿，待业在家帮妈看摊收钱，一双手冻得通红，账却从没错过一笔。',
                level: 1,
                gender: 'female',
                requirements: [{ attr: 'charm', value: 5 }],
                shootWeeks: 1,
                attributeGrowth: { charm: 2 },
            }
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Period, ScriptTheme.LifeStyle],
        heat: 20,
        baseScore: 7.4,
    },
    {
        id: 'SCRIPT_019',
        name: '白月光退货指南',
        genre: 'short',
        synopsis: '加班猝死的时绥一睁眼，成了言情小说里三年前车祸去世的白月光，全套人生只剩男主霍今照的悼念戏份。想回家，得让男主亲手把定情信物送进当铺——书里的说法叫"放下"。她顶着路人配角的脸，在他楼下开了家二手寄卖行，专收旧物，兼收心事。收到第三个月，她翻到了白月光本人留下的日记：原来那位也没打算结婚，只是没来得及说。',
        roles: [
            {
                name: '时绥',
                roleType: '女主角',
                billing: 1,
                intro: '社畜十年，最大的本事是劝人断舍离。寄卖行开在写字楼后街，招牌手写，规矩三条：东西要擦干净，故事讲不讲随意，眼泪不额外收费。她劝霍今照放了"她"，越劝越像在劝自己。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
            {
                name: '霍今照',
                roleType: '男主角',
                billing: 1,
                intro: '建筑师，白天画别人的房子，晚上守着一套没装修完的婚房图纸。劝他往前走的人不少，他听得懂，只是做不到。直到楼下那家寄卖行开张，他鬼使神差抱去了一箱没拆封的喜糖。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'temperament', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { charm: 3, temperament: 2 },
            },
            {
                name: '乔楠',
                roleType: '女二号',
                billing: 2,
                intro: '白月光生前最好的朋友，唯一记得她怕黑的人。三年里她替死者把朋友圈设成三天可见，逢忌日发一条仅自己可见的想念。寄卖行她第一个上门，寄的东西是一台没送出去的加湿器。',
                level: 3,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 18 },
                    { attr: 'charm', value: 15 },
                ],
                shootWeeks: 2,
                attributeGrowth: { temperament: 2, charm: 2 },
            },
            {
                name: '祝有酒',
                roleType: '男二号',
                billing: 2,
                intro: '霍今照的合伙人，嘴上没正形，办事最稳。他头一个发现老板总往寄卖行跑，也头一个发现老板娘笑起来有点眼熟。他没说，只是把寄卖行的招牌灯，换了盏长明的。',
                level: 3,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 18 },
                    { attr: 'wisdom', value: 15 },
                ],
                shootWeeks: 2,
                attributeGrowth: { temperament: 2, wisdom: 2 },
            }
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Urban, ScriptTheme.LifeStyle, ScriptTheme.Romance],
        heat: 22,
        baseScore: 6.4,
    },
    {
        id: 'SCRIPT_020',
        name: '来路不明',
        genre: 'short',
        synopsis: '独居的蒙世坤老人记性一天坏过一天，新来的住家保姆记性却出奇地好——她叫仇晓，实为二十六年前失踪于这条街的运输司机之女，应聘上门只为套出老人胡话里的旧事。老爷子说胡话有条理得很：谁的车、哪座桥、箱子里装的什么。可他偶尔清醒时，会忽然喊出她的乳名。第三个月，仇晓发现自己伺候的，可能是全城唯一记得真相的人，也可能是唯一不想让真相出来的人。',
        roles: [
            {
                name: '仇晓',
                roleType: '女主角',
                billing: 1,
                intro: '父亲失踪那年她还没满月，卷宗里就一行字：自行走失。护理专业毕业，在养老院做过三年，进蒙家前把老人的病历背得滚瓜烂熟。白天她是话少的保姆，夜里整理录音，一根一根对日子。',
                level: 3,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 18 },
                    { attr: 'wisdom', value: 15 },
                ],
                shootWeeks: 3,
                attributeGrowth: { charm: 2, wisdom: 2 },
            },
            {
                name: '小琴',
                roleType: '女配角',
                billing: 4,
                intro: '家政公司派单员，仇晓的活儿一半是她排的，嘴快但心善，抽屉里锁着一份没敢交的辞职信。',
                level: 1,
                gender: 'female',
                requirements: [{ attr: 'charm', value: 5 }],
                shootWeeks: 1,
                attributeGrowth: { charm: 2 },
            }
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Mystery, ScriptTheme.LifeStyle],
        heat: 17,
        baseScore: 5.2,
    },
    {
        id: 'SCRIPT_021',
        name: '借脸',
        genre: 'short',
        synopsis: '画师佘绘真被请进知州府，给"骤病去世"的独生小姐画遗容。画到第三稿，知州开了口：夫人疯了，只认活的女儿——请姑娘描容之后，再借容几日，扮一扮小姐。绘真应了，却越扮越心惊：小姐的病来得蹊跷，陪嫁清单上少的那一件，和夫人夜夜添在画像上的那一笔，指的是同一个地方。',
        roles: [
            {
                name: '佘绘真',
                roleType: '女主角',
                billing: 1,
                intro: '父女两代给人画遗容，规矩是死人的脸要画得比活人厚道。她过手的遗容没一张被挑出错，唯独这张画了三稿——不是手生，是想让活着的人看出点什么。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { charm: 3, talent: 2 },
            },
            {
                name: '涂验清',
                roleType: '男主角',
                billing: 1,
                intro: '州衙仵作，人短了命，他负责把话补全。验不明的案子他偏接，上头忌讳他又离不得他。头一回见佘绘真是在义庄，她来画遗容，他来翻骨——都是替死人说话的。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'wisdom', value: 30 },
                    { attr: 'temperament', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { wisdom: 3, temperament: 2 },
            },
            {
                name: '栗子',
                roleType: '女配角',
                billing: 3,
                intro: '小姐的贴身丫鬟，主子走后被塞了婚，塞到百里外的山村。绘真扮小姐头一天，她跪在院里磕了三个头——磕给小姐，也磕给这位肯借脸的陌生人。',
                level: 2,
                gender: 'female',
                requirements: [{ attr: 'charm', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { charm: 3 },
            }
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Mystery, ScriptTheme.Ancient],
        heat: 25,
        baseScore: 6.7,
    },
    {
        id: 'SCRIPT_022',
        name: '晚安曲',
        genre: 'short',
        synopsis: '一九三五年上海。电台午夜点播栏目《晚安曲》收到一张点播单，点的是支老掉牙的华尔兹，留言一行字：送给将死之人。七天后，点播人果然出了事。第二张、第三张单子陆续寄到，播音员卫枝不敢再念，探长翟午桥却盯上了这叠单子——头联全被撕掉的点播单，背面誊的是同一个人的笔迹。',
        roles: [
            {
                name: '卫枝',
                roleType: '女主角',
                billing: 1,
                intro: '电台深夜档播音员，嗓音是台里的招牌。台规念稿不带情绪，她偏在念到第三张单子那晚顿了顿——就这一顿，让收音机前的人知道，念单子的人也怕。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
            {
                name: '翟午桥',
                roleType: '男主角',
                billing: 1,
                intro: '巡捕房华探，上司眼里他最不开窍——旁人抢破头的大案他不碰，专管这些没人报案的"巧事"。七天一个，巧得像在对表。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'wisdom', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { wisdom: 3, talent: 2 },
            },
            {
                name: '柳莺时',
                roleType: '女二号',
                billing: 2,
                intro: '《晚安曲》的常驻歌手，点播单上那支曲子是她唱红的。头一张单子寄到时她正要出唱片，出了事唱片公司把她的歌全下了——她比谁都想知道，谁在借她的歌"送人"。',
                level: 3,
                gender: 'female',
                requirements: [
                    { attr: 'artistry', value: 18 },
                    { attr: 'charm', value: 15 },
                ],
                shootWeeks: 2,
                attributeGrowth: { artistry: 2, charm: 2 },
            },
            {
                name: '水根',
                roleType: '男配角',
                billing: 3,
                intro: '留声机行学徒，全城的唱片都从他手里过。点播那支曲子的钢片他存了独一份，警察问到头上，他交出钢片，没交借片人的名字。',
                level: 2,
                gender: 'male',
                requirements: [{ attr: 'temperament', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { temperament: 3 },
            },
            {
                name: '阿岱',
                roleType: '男配角',
                billing: 4,
                intro: '电台送稿学徒，点播单头一个送到直播间的总是他，抄写工整得像印的。',
                level: 1,
                gender: 'male',
                requirements: [{ attr: 'charm', value: 5 }],
                shootWeeks: 1,
                attributeGrowth: { charm: 2 },
            }
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Mystery, ScriptTheme.Period, ScriptTheme.Crime],
        heat: 21,
        baseScore: 5.9,
    },
    {
        id: 'SCRIPT_023',
        name: '劝离',
        genre: 'short',
        synopsis: '离婚登记处书记员廉素心，见过千奇百怪的分手，"劝和不劝离"的规矩背得比结婚誓词还熟。轮到自己被离婚那天，丈夫谭家骥的财产早转成了三家空壳公司。她没闹，翻出抽屉里那本记了二十三年的手账——劝不动的人怎么藏钱，她一笔一笔都见过。',
        roles: [
            {
                name: '麦冬',
                roleType: '女二号',
                billing: 2,
                intro: '房产中介，经手过谭家骥两套"卖给亲戚"的房子。起初她装糊涂——糊涂有提成。素心没揭穿，只在客户名单里圈出她姑妈的名字。麦冬想了一晚，第二天带着全套合同上了门。',
                level: 3,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 18 },
                    { attr: 'temperament', value: 15 },
                ],
                shootWeeks: 2,
                attributeGrowth: { charm: 2, temperament: 2 },
            },
            {
                name: '廉迟',
                roleType: '女配角',
                billing: 3,
                intro: '廉素心女儿，法律专业，在图书馆帮妈查判例查到闭馆。劝妈"算了"那晚，她翻到手账里有自己小学每学期的学费记录，一笔没落。第二天她把辞掉的实习又接了回来——打官司要钱，更要把日子过直。',
                level: 2,
                gender: 'female',
                requirements: [{ attr: 'wisdom', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { wisdom: 3 },
            }
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.LifeStyle, ScriptTheme.Female],
        heat: 19,
        baseScore: 6.2,
    },
    {
        id: 'SCRIPT_024',
        name: '狗都知道',
        genre: 'short',
        synopsis: '退役搜救犬大桔的后腿带着旧伤，训导员苑北望退下来，开了间"寻回事务所"，专接找人找物的小委托。开张头一个上门的岑枝春，儿子走失七年，寻亲群里的线索试了一轮又一轮，这回她带来最后一件东西——半张游乐场门票。事务所接了这单不赚钱的生意：大桔闻过的气味，比人记得的事多。',
        roles: [
            {
                name: '岑枝春',
                roleType: '女主角',
                billing: 1,
                intro: '寻亲的路她走成了本地通，哪年哪城有认亲大会，她比通告记得清。儿子的味道她说不出来，只说得出他顶爱吃桔子——这句话，后来成了大桔的命令。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
            {
                name: '苑北望',
                roleType: '男主角',
                billing: 1,
                intro: '训导员退下来，队里给他留了文职，他没要。事务所的收费牌写得实诚：找回收全款，找不回收个狗粮钱。别人问图什么，他摸摸大桔的耳朵——有些事人间只剩这么一条路，总得有人走。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'stamina', value: 30 },
                    { attr: 'charm', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { stamina: 3, charm: 2 },
            },
            {
                name: '小苏',
                roleType: '女配角',
                billing: 4,
                intro: '事务所接待兼账号运营，毛遂自荐应聘的唯一理由是"我认路快"，全城寻亲群的接龙她每天核对到半夜。',
                level: 1,
                gender: 'female',
                requirements: [{ attr: 'charm', value: 5 }],
                shootWeeks: 1,
                attributeGrowth: { charm: 2 },
            }
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.LifeStyle],
        heat: 20,
        baseScore: 6.6,
    },
    {
        id: 'SCRIPT_025',
        name: '打烊之前',
        genre: 'short',
        synopsis: '池半夏接手父亲的深夜面摊，立了条新规矩：讲个故事，面钱打半折。美食城的招商经理戈清让想把这条街整层收编，她想守住这口锅。每集一位客人，每人一段心事，一碗面下肚，都说吃出了家的味道。街对面招商计划书改到第三稿，这口锅还没挪窝。',
        roles: [
            {
                name: '池半夏',
                roleType: '女主角',
                billing: 1,
                intro: '面摊老板，汤头是父亲传的，规矩是自己立的。客人哭她加一勺辣，客人笑她撒把葱。来吃面的人换了一茬又一茬，她的汤头一直是那一锅。',
                level: 3,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 18 },
                    { attr: 'temperament', value: 15 },
                ],
                shootWeeks: 3,
                attributeGrowth: { charm: 2, temperament: 2 },
            },
            {
                name: '晏北',
                roleType: '男主角',
                billing: 1,
                intro: '夜班出租车司机，收车必来，只坐同一个位子。他每回来都讲个新故事，半夏听完只问一句"明天还出车吗"，他就点头。',
                level: 3,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 18 },
                    { attr: 'temperament', value: 15 },
                ],
                shootWeeks: 3,
                attributeGrowth: { charm: 2, temperament: 2 },
            },
            {
                name: '戈清让',
                roleType: '女二号',
                billing: 2,
                intro: '美食城招商经理，PPT里装着整条街的未来。她跟半夏交手十几个回合，收编方案改了一版又一版，落款日期一直空着。',
                level: 2,
                gender: 'female',
                requirements: [{ attr: 'temperament', value: 12 }],
                shootWeeks: 2,
                attributeGrowth: { temperament: 3 },
            },
            {
                name: '毛豆',
                roleType: '男配角',
                billing: 5,
                intro: '隔壁烧烤摊学徒，收摊总来蹭半碗面汤，顺手把摊子的竹签烧了，还想跟半夏学两句招牌上的字。',
                level: 1,
                gender: 'male',
                requirements: [{ attr: 'charm', value: 5 }],
                shootWeeks: 1,
                attributeGrowth: { charm: 2 },
            }
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Urban, ScriptTheme.LifeStyle],
        heat: 16,
        baseScore: 4.9,
    },
    {
        // 晋升二线固定送本（2026-10-27 茄子令「升到 Lv.5 固定送一个角色，专门写个剧本，先暂定」）：
        // 不占排期表，开拍月随签约次月（shootStartAbsOf fallback 口径）；由 DirectSignSystem.issuePromotionOffer 派发。
        id: 'SCRIPT_T05',
        name: '雾中来信',
        genre: 'short',
        synopsis: '二十四集悬疑情感短剧。旧城邮政大楼的死信科，收留所有无人认领的信。整理员苏青在退回一封被雨水泡透的信时，发现收信人一栏写着自己的名字——寄信日期，是十年后。剧组看过你上一部戏，指名要你。',
        roles: [
            {
                name: '苏青',
                roleType: '女主角',
                billing: 1,
                intro: '死信科整理员，性子静，拆信前先给信封烘干。十年间替人读完了三千封寄不出去的话，直到那封写着自己名字的信出现在桌角。',
                level: 4,
                gender: 'female',
                requirements: [{ attr: 'charm', value: 25 }],
                shootWeeks: 4,
                attributeGrowth: { talent: 2, wisdom: 1 },
            },
            {
                name: '沈述',
                roleType: '男主角',
                billing: 1,
                intro: '邮局隔壁修钟表的匠人，只修不卖，铺子里所有钟指着同一个时刻。他说死信科的信和他铺子里的钟一样，等的都是迟来的人。',
                level: 4,
                gender: 'male',
                requirements: [{ attr: 'charm', value: 30 }],
                shootWeeks: 3,
                attributeGrowth: { talent: 1 },
            },
            {
                name: '阿禾',
                roleType: '女二号',
                billing: 2,
                intro: '苏青的同事，负责销毁超期信件，是全楼唯一敢在夜里加班的人。她最先发现那些「十年后寄出」的信不止一封。',
                level: 3,
                gender: 'female',
                requirements: [{ attr: 'charm', value: 15 }],
                shootWeeks: 2,
                attributeGrowth: { charm: 1 },
            },
            {
                name: '老陈',
                roleType: '男配角',
                billing: 4,
                intro: '邮政大楼看门人，在死信科隔壁守了半辈子。楼里人都说他记性差，可十年前的事，他记得比谁都清。',
                level: 3,
                gender: 'male',
                requirements: [{ attr: 'charm', value: 10 }],
                shootWeeks: 1,
                attributeGrowth: { stamina: 1 },
            }
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Urban, ScriptTheme.LifeStyle],
        heat: 24,
        baseScore: 5.8,
    },
];
